import { Record } from 'immutable';

const EventMenuSearchFilterPaymentStatusRecord = Record({
  inProcess: true,
  unpaid: true,
  paid: true
});

export class EventMenuSearchFilterPaymentStatus extends EventMenuSearchFilterPaymentStatusRecord {
  inProcess: boolean;
  unpaid: boolean;
  paid: boolean;
}


const EventMenuSearchFilterRecord = Record({
  commissionId: null,
  fundingReferenceId: null,
  paymentReferenceId: null,
  startDate: null,
  endDate: null,
  guestName: null,
  eventStatusCompleted: false,
  eventStatusMissingAgency: false,
  paymentStatus: {
    inProcess: true,
    unpaid: true,
    paid: true
  }

});

export class EventMenuSearchFilter extends EventMenuSearchFilterRecord {
  commissionId: string;
  fundingReferenceId: string;
  paymentReferenceId: string;
  startDate: string;
  endDate: string;
  guestName: string;
  eventStatusMissingAgency: boolean;
  eventStatusCompleted: boolean;
  paymentStatus: EventMenuSearchFilterPaymentStatus;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/event-menu-search-filter.ts